import './review-sections.css'

interface CausalChain {
  hypothesis: string
  predicted_movement: { metric: string; direction: string; magnitude: string }
  actual_movement: { metric: string; direction: string; magnitude: string }
  chain_held: boolean
  assessment: string
}

interface CausalAuditData {
  chains: CausalChain[]
}

interface Props {
  data: CausalAuditData
}

function parseBscFlow(hypothesis: string): string[] {
  const perspectives = ['Learning & Growth', 'Internal Process', 'Customer', 'Financial']
  const found: string[] = []
  for (const p of perspectives) {
    if (hypothesis.toLowerCase().includes(p.toLowerCase()) ||
        (p === 'Learning & Growth' && hypothesis.includes('L&G'))) {
      found.push(p)
    }
  }
  return found.length > 0 ? found : ['Unknown']
}

function getBscNodeClass(perspective: string): string {
  const p = perspective.toLowerCase()
  if (p.includes('financial')) return 'bsc-financial'
  if (p.includes('customer')) return 'bsc-customer'
  if (p.includes('process')) return 'bsc-process'
  if (p.includes('learning') || p.includes('growth')) return 'bsc-learning'
  return ''
}

export default function CausalAuditSection({ data }: Props) {
  return (
    <div>
      <p className="section-hint">
        Did your strategic logic hold? Compares what you predicted would happen against what actually did.
      </p>

      {(data.chains || []).map((chain, i) => {
        const flow = parseBscFlow(chain.hypothesis)
        return (
          <div key={i} className="review-card">
            <div className="chain-flow">
              {flow.map((node, j) => (
                <span key={j}>
                  <span className={`chain-node ${getBscNodeClass(node)}`}>{node}</span>
                  {j < flow.length - 1 && <span className="chain-arrow"> → </span>}
                </span>
              ))}
            </div>

            <p className="review-card-body" style={{ fontSize: 12, marginBottom: 8 }}>
              {chain.hypothesis}
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
              <div style={{ fontSize: 12 }}>
                <strong>Predicted:</strong> {chain.predicted_movement.metric}{' '}
                {chain.predicted_movement.direction} {chain.predicted_movement.magnitude}
              </div>
              <div style={{ fontSize: 12 }}>
                <strong>Actual:</strong> {chain.actual_movement.metric}{' '}
                {chain.actual_movement.direction} {chain.actual_movement.magnitude}
              </div>
            </div>

            <div className={`chain-result ${chain.chain_held ? 'chain-held' : 'chain-broken'}`}>
              <span style={{ fontSize: 18 }}>{chain.chain_held ? '\u2713' : '\u2717'}</span>
              <span style={{ fontSize: 13, fontWeight: 600 }}>
                {chain.chain_held ? 'Chain Validated' : 'Chain Broken'}
              </span>
            </div>

            <p className="review-card-body">{chain.assessment}</p>
          </div>
        )
      })}

      {(!data.chains || data.chains.length === 0) && (
        <p style={{ fontSize: 13, color: '#666', fontStyle: 'italic' }}>
          No causal chain data available for this cycle.
        </p>
      )}
    </div>
  )
}
